module.exports = __webpack_public_path__ + "img/more-info.0a6674c7.svg";